import useEventUniqueName from '../useEventUniqueName';
import { useEventDetailsContext } from '../../contexts/RingContext';

const useVenueUrl = (url = '') => {
    const eventUniqueName = useEventUniqueName();

    const { isEventWhiteLabel, whitelabelPath } = useEventDetailsContext();
    if (isEventWhiteLabel) {
        return (whitelabelPath ?? '') + '/venue' + url;
    }

    const baseUrl = `/${eventUniqueName}`;
    return baseUrl + url;
};

export default useVenueUrl;
